module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook.9a8e99e3.jpg";